const features = [
  {
    icon: 'ri-search-eye-line',
    title: 'Product Discovery',
    description: 'Find products faster through organized resources and curated category listings designed for international shoppers.',
  },
  {
    icon: 'ri-stack-line',
    title: 'Category Navigation',
    description: 'Browse products by well-organized categories including shoes, hoodies, jackets, bags, and accessories.',
  },
  {
    icon: 'ri-book-open-line',
    title: 'Shopping Research',
    description: 'Understand products better before buying with detailed comparison tools and structured information resources.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'QC Understanding',
    description: 'Learn how quality checking works and what to look for when reviewing product photos and specifications.',
  },
  {
    icon: 'ri-calculator-line',
    title: 'Cost Planning',
    description: 'Compare prices and shipping information across different products to make informed purchasing decisions.',
  },
  {
    icon: 'ri-user-heart-line',
    title: 'Beginner Support',
    description: 'Follow simple shopping guides designed for first-time international buyers to get started confidently.',
  },
];

export default function FeaturesSection() {
  return (
    <section className="py-24 md:py-32 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="font-heading text-3xl md:text-5xl font-semibold text-foreground-950 mb-4">
            Why Users Search Superbuy Spreadsheet
          </h2>
          <p className="text-foreground-500 text-base md:text-lg max-w-[650px] mx-auto">
            Six powerful reasons why international shoppers rely on organized resources for smarter product discovery
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="group p-6 md:p-8 rounded-2xl bg-background-100 hover:bg-background-200/70 transition-colors"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100/70 flex items-center justify-center mb-5 group-hover:bg-primary-200/70 transition-colors">
                <i className={`${feat.icon} text-primary-500 text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">
                {feat.title}
              </h3>
              <p className="text-foreground-500 text-sm leading-relaxed">
                {feat.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}